var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"type":"number","label":_vm.label,"disabled":_vm.disabled,"outlined":_vm.outlined,"dense":_vm.dense,"hide-details":_vm.hideDetails,"rules":_vm.rules},on:{"change":_vm.update,"input":_vm.update},model:{value:(_vm.str),callback:function ($$v) {_vm.str=$$v},expression:"str"}})
}
var staticRenderFns = []

export { render, staticRenderFns }